import React from 'react'
import './footer.css';

const Footer = () => {
  return (
    <div>
        <section className='footer mt-5'>
            <div className='footer-section text-center'>
                 <p>Ciddarth RM | 2025 All Rights Reserved</p>
            </div>
        </section>

    </div>
  )
}

export default Footer
